import * as ContactsEffects from './contacts.effect';

export const effects = { ...ContactsEffects };
